import React__default from 'react';
import styled, { useTheme } from 'styled-components';
import { useIsMobile, Icon } from '@amzn/storm-ui';
import { F as FeedbackFormThemeProvider } from './FeedbackFormThemeProvider-BtQQn72x.js';
import { F as FormLayoutWrapper } from '../internalComponents/FormLayout/FormLayoutWrapper-BLcX_Mmv.js';
import { f as faSpinner } from '../LocalModules/storm-ui-icons/dist/esm/fortawesome-free-solid-svg-icons-B7FqziTJ-C1x4Faml.js';

const PlaceholderWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30062554__sc-19yz2nn-0"
})(["height:", ";display:flex;align-items:center;justify-content:center;padding:", ";"], ({
  $isMobile,
  $isModal
}) => $isModal || $isMobile ? undefined : '200px', ({
  $isModal,
  theme
}) => $isModal ? theme.spacing.base : '0px');
const Placeholder = ({
  anchorElement,
  type,
  isOpen,
  onClose,
  popperOffset,
  popperPlacement,
  popperStrategy
}) => {
  var _theme$feedbackForm, _theme$feedbackForm2;
  const theme = /*#__PURE__*/useTheme();
  const defaultIsMobile = useIsMobile();
  const isMobile = defaultIsMobile !== null && defaultIsMobile !== void 0 ? defaultIsMobile : false;
  return /*#__PURE__*/React__default.createElement(FormLayoutWrapper, {
    anchorElement: anchorElement,
    isMobile: isMobile,
    type: type,
    isOpen: isOpen,
    isPlaceholder: true,
    onClose: onClose,
    popperOffset: popperOffset,
    popperPlacement: popperPlacement,
    popperPortalElementId: theme === null || theme === void 0 || (_theme$feedbackForm = theme.feedbackForm) === null || _theme$feedbackForm === void 0 || (_theme$feedbackForm = _theme$feedbackForm.popper) === null || _theme$feedbackForm === void 0 ? void 0 : _theme$feedbackForm.portalElementId,
    popperStrategy: popperStrategy,
    popperStyle: theme === null || theme === void 0 || (_theme$feedbackForm2 = theme.feedbackForm) === null || _theme$feedbackForm2 === void 0 ? void 0 : _theme$feedbackForm2.popper
  }, /*#__PURE__*/React__default.createElement(PlaceholderWrapper, {
    $isMobile: isMobile,
    $isModal: type === 'modal'
  }, /*#__PURE__*/React__default.createElement(Icon, {
    type: faSpinner,
    size: "2x"
  })));
};
const FeedbackFormPlaceholder = ({
  anchorElement,
  isMobile,
  type,
  isOpen,
  onClose,
  popperOffset,
  popperPlacement,
  popperStrategy,
  theme
}) => /*#__PURE__*/React__default.createElement(FeedbackFormThemeProvider, {
  theme: theme,
  isMobile: isMobile
}, /*#__PURE__*/React__default.createElement(Placeholder, {
  anchorElement: anchorElement,
  type: type,
  isOpen: isOpen,
  onClose: onClose,
  popperOffset: popperOffset,
  popperPlacement: popperPlacement,
  popperStrategy: popperStrategy
}));

export { FeedbackFormPlaceholder as F };
//# sourceMappingURL=FeedbackFormPlaceholder-CT8njHa2.js.map
